import {
  callOnBeforeRun,
  ChatUiEventTypes,
  sendChatUiEvent,
} from '@trimble-agentic-external-npm-local/agentic-platform-sdk-iframe-typescript';
import {
  FullChat,
  type ContentVariants as ChatUiContentVariants,
  type RunContextCallback,
} from '@trimble-agentic-internal-npm-local/agentic-chat-ui';
import { useCallback, useContext } from 'react';

import { EmbeddedConfigContext } from '../providers/embedded-config-provider';
import { mapDynamicToolsToRunContext } from '../utilities/toolUtils';

export const EmbeddedFullChat = () => {
  const context = useContext(EmbeddedConfigContext);

  const handleChatInputButtonClick = useCallback((buttonId: string) => {
    sendChatUiEvent({
      type: ChatUiEventTypes.OnChatInputButtonClick,
      payload: buttonId,
    });
  }, []);

  const handleOnBeforeRun = useCallback(
    async (
      agentId: string
    ): Promise<Awaited<ReturnType<RunContextCallback>>> => {
      const dynamicRunContext = await callOnBeforeRun(
        agentId,
        context?.chatConfig.onBeforeRunTimeout
      );

      return mapDynamicToolsToRunContext(dynamicRunContext);
    },
    [context?.chatConfig.onBeforeRunTimeout]
  );

  return (
    <div className='h-[100dvh] w-[100dvw]'>
      <FullChat
        agentId={context?.chatConfig.agentId || ''}
        threadId={context?.chatConfig.threadId}
        chatInputButtons={context?.chatConfig.uiConfig.chatInput.buttons}
        onChatInputButtonClick={handleChatInputButtonClick}
        hideModelSelection={
          context?.chatConfig.uiConfig.chatInput.hideModelSelection
        }
        contentVariant={
          context?.chatConfig.uiConfig.contentVariant as
            | ChatUiContentVariants
            | undefined
        }
        onBeforeRunCall={handleOnBeforeRun}
        onAgentSelect={agentId => {
          sendChatUiEvent({
            type: ChatUiEventTypes.OnAgentSelect,
            payload: agentId,
          });
        }}
        onThreadSelect={() => {
          sendChatUiEvent({
            type: ChatUiEventTypes.OnThreadSelect,
            payload: undefined,
          });
        }}
        onNewChat={() => {
          sendChatUiEvent({
            type: ChatUiEventTypes.OnNewChat,
            payload: undefined,
          });
        }}
        onExploreAgents={() => {
          sendChatUiEvent({
            type: ChatUiEventTypes.OnExploreAgents,
            payload: undefined,
          });
        }}
        onCreateAgent={() => {
          sendChatUiEvent({
            type: ChatUiEventTypes.OnCreateAgent,
            payload: undefined,
          });
        }}
      />
    </div>
  );
};
